module.exports = __webpack_public_path__ + "img/index_bottom1.225cd1ea.png";